import Sidebar from "../common/sidebar";
import Topbar from "../common/topbar";
import { Outlet } from "react-router-dom";

import {
  SIDEBAR_TOP_LEFT_IMAGE,
} from "../../utils/aap-image-constant";

const FirstLayout = ({ setSidebarShow, sidebarShow }) => {
  return (
    //FOR TWO PARTS SIDEBAR AND MAIN BODY
    <div className="container-fluid screen-height bg-primary  overflow-hidden">
      <img
        src={SIDEBAR_TOP_LEFT_IMAGE}
        className=" img-top-left  position-absolute mb-5"
        alt="icon"
      ></img>

      <div className="row flex-nowrap h-100 overflow-hidden">
        <Sidebar setSidebarShow={setSidebarShow} sidebarShow={sidebarShow} />

        <div className="p-2 z-1 col table_resp_dnp h-100 ">
          <div className=" px-lg-4 px-2 bg-off-white rounded-30 h-100  Topbar-content  ">
            <div className="">
              <Topbar
                sidebarShow={sidebarShow}
                setSidebarShow={setSidebarShow}
              />
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstLayout;
